import PropTypes from "prop-types";

/*
    Representation of src/ssaw/portal/template_serializers/modules/product_card.py
*/
export const ProductCardPropType = PropTypes.shape({
    affiliate_promo_url: PropTypes.string,
    algolia_metadata: PropTypes.object,
    context_type: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    description: PropTypes.string,
    designer_name: PropTypes.string.isRequired,
    designer_slug: PropTypes.string.isRequired,
    detail_lead_enabled: PropTypes.bool,
    discount_info: PropTypes.string,
    free_shipping: PropTypes.bool.isRequired, // Default false
    full_price_machine_readable_integer_string: PropTypes.string,
    full_price_with_currency_symbol: PropTypes.string,
    gender: PropTypes.oneOf(["M", "F"]),
    has_variant: PropTypes.bool.isRequired,
    icon_enabled: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    image_alt_text: PropTypes.string.isRequired,
    image_url: PropTypes.string,
    in_stock: PropTypes.bool.isRequired,
    is_affiliate: PropTypes.bool.isRequired,
    lead_enabled: PropTypes.bool.isRequired,
    lead_url: PropTypes.string,
    link_id: PropTypes.number,
    on_promotion: PropTypes.bool.isRequired,
    overlay_enabled: PropTypes.bool.isRequired,
    retailer_name: PropTypes.string.isRequired,
    sale_badge: PropTypes.string,
    sale_discount: PropTypes.number,
    sale_price_machine_readable_integer_string: PropTypes.string,
    sale_price_with_currency_symbol: PropTypes.string,
    short_description: PropTypes.string,
    show_offer_meta: PropTypes.bool.isRequired,
    show_retailer_as_affiliate: PropTypes.bool.isRequired,
    slug: PropTypes.string.isRequired,
    uid: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    use_lazy_images: PropTypes.bool.isRequired,
    use_new_tab_logic: PropTypes.bool.isRequired,
    use_overlay_on_mobile: PropTypes.bool.isRequired,
});

export interface ProductCardType {
    affiliate_promo_url?: string;
    algolia_metadata?: any; // TODO better type def here
    context_type: string;
    currency: string;
    description?: string;
    designer_name: string;
    designer_slug: string;
    detail_lead_enabled?: boolean;
    discount_info?: string;
    free_shipping: boolean; // Default fals;
    full_price_machine_readable_integer_string?: string;
    full_price_with_currency_symbol?: string;
    gender: "M" | "F";
    has_variant: boolean;
    icon_enabled: boolean;
    id: number;
    image_alt_text: string;
    image_url?: string;
    in_stock: boolean;
    is_affiliate: boolean;
    lead_enabled: boolean;
    lead_url?: string;
    link_id?: number;
    on_promotion: boolean;
    overlay_enabled: boolean;
    retailer_name: string;
    sale_badge?: string;
    sale_discount?: number;
    sale_price_machine_readable_integer_string?: string;
    sale_price_with_currency_symbol?: string;
    short_description?: string;
    show_offer_meta: boolean;
    show_retailer_as_affiliate: boolean;
    slug: string;
    uid: string;
    url: string;
    use_lazy_images: boolean;
    use_new_tab_logic: boolean;
    use_overlay_on_mobile: boolean;
}
